import type { StaffMember } from '../../../../api/staff';

import { regionTag } from './crewModel';
import { CrewPickerHint } from './CrewPickerHint';
import { CrewPickerResultRow } from './CrewPickerResultRow';

export function CrewPickerResultList({
  isLoading,
  hasError,
  results,
  onPick,
  inRegionIds,
}: {
  isLoading: boolean;
  hasError: boolean;
  results: StaffMember[];
  onPick: (member: { userId: string; name: string }) => void;
  /** Set in all-staff mode (BON-390): the ids the region-scoped list holds.
   *  Members with no region get a "No region" tag and members not in this set
   *  get "Outside region". Null in region mode (all rows match). */
  inRegionIds: ReadonlySet<string> | null;
}) {
  return (
    <div style={{ overflow: 'auto', display: 'flex', flexDirection: 'column', gap: 2 }}>
      {isLoading && <CrewPickerHint>Loading staff…</CrewPickerHint>}
      {hasError && <CrewPickerHint tone="warn">Could not load staff.</CrewPickerHint>}
      {!isLoading && !hasError && results.length === 0 && (
        <CrewPickerHint>
          {inRegionIds === null ? 'No matching staff in this region.' : 'No matching staff.'}
        </CrewPickerHint>
      )}
      {results.map((s) => (
        <CrewPickerResultRow
          key={s.id}
          member={s}
          onPick={onPick}
          regionTag={regionTag(s, inRegionIds)}
        />
      ))}
    </div>
  );
}
